import React, { Component } from 'react'
import ProfessionalForm from '@modules/admin/professionals/Professional.Form'
import { Trans, withTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { DashboardHeader } from '@modules/admin/Admin.Header'
import Consultations from '@services/Consultations'

class CreateProfessional extends Component {
  state = {
    newProfessional: {
      translations: [{ language: { iso_code: 'es', name: 'Español' } }],
      is_visible_offline: true,
      roles: [{ name: 'professional', id: 4 }],
      access_type: 'support',
      can_prescribe: false,
    },
    professionalRoles: [],
  }
  componentDidMount() {
    this.fetchProfessionalRoles()
  }
  fetchProfessionalRoles = async () => {
    try {
      const response = await Consultations.professionalRoles.index()
      this.setState({ professionalRoles: response.data })
    } catch (e) {
      console.error(e.message)
    }
  }

  render() {
    const { professionalRoles } = this.state
    return (
      <div className="crud-wrapper professional-wrapper">
        <div className="professional-create">
          <DashboardHeader title={<Trans>Nuevo Professional</Trans>}>
            <Link className="btn btn-primary" to={`/professional`}>
              <Trans>Volver</Trans>
            </Link>
          </DashboardHeader>
          <div className="container-fluid main-content">
            <ProfessionalForm initialValues={this.state.newProfessional} professionalRoles={professionalRoles} />
          </div>
        </div>
      </div>
    )
  }
}

export default withTranslation()(CreateProfessional)
